<template>
  <div class="courses-banner">
    <div class="courses-banner__text">
      <h1 class="courses-banner__title">
        образовательные
        <br>
        курсы для детей
      </h1>

      <p class="courses-banner__description">
        получите <span>бесплатный</span> доступ к любому курсу
        <br>
        на 30 дней — откройте будущее для вашего ребенка
      </p>
    </div>

    <div class="courses-banner__cards">
      <div class="courses-banner__card">
        <h6>
          <span class="green">^</span>
          <span class="white">№ 1</span>
        </h6>

        <p>
          *крупнейшие EdTech’и
          <br>
          по версии Smart Ranking
        </p>

        <img
          src="/v2/catalog-courses/banner/sticker.png"
          alt="3"
        >
      </div>
      <div class="courses-banner__card">
        <h6>
          c
          <span class="white">1999</span>
          года
        </h6>

        <p>
          обучаем подростков
          <br>
          и детей онлайн
        </p>
      </div>
      <div class="courses-banner__card">
        <h6>
          >
          <span class="white">500 000</span>
        </h6>

        <p>
          выпускников
        </p>
      </div>
    </div>

    <button
      class="courses-banner__button"
      @click="scrollTo('.courses-cards')"
    >
      подобрать курс
    </button>

    <img
      src="/v2/catalog-courses/banner/down.svg"
      alt="down"
      class="courses-banner__down"
      @click="scrollTo('.courses-cards')"
    >
  </div>
</template>

<script>
import scrollTo from '~/utils/scrollTo';

export default {
  name: 'CatalogCoursesBanner',
  methods: {
    scrollTo(el) {
      scrollTo(el);
    },
  },
};
</script>

<style lang="scss" scoped>
.courses-banner {
  display: flex;
  flex-direction: column;
  position: relative;

  width: 100%;
  height: calc(var(--scale) * 512);
  padding: calc(var(--scale) * 24)
  calc(var(--scale) * 40)
  calc(var(--scale) * 40)
  calc(var(--scale) * 40);
  box-sizing: border-box;

  border-radius: calc(var(--scale) * 60);
  background-image: url("/v2/catalog-courses/banner/banner-bg.webp");
  background-size: cover;
  background-position: center center;

  @include media-down($size-tablet) {
    height: calc(var(--scale) * 440);
    padding: calc(var(--scale) * 20)
    calc(var(--scale) * 8)
    calc(var(--scale) * 8)
    calc(var(--scale) * 8);

    border-radius: calc(var(--scale) * 32);
    background-image: url("/v2/catalog-courses/banner/banner-bg-tablet.webp");
  }

  @include media-down($size-mobile) {
    height: calc(var(--scale) * 560);
    padding: calc(var(--scale) * 20)
    0
    calc(var(--scale) * 8)
    0;
    overflow: hidden;

    background-image: url("/v2/catalog-courses/banner/banner-bg-mobile.webp");
  }

  &__text {
    @include media-down($size-tablet) {
      padding: 0 calc(var(--scale) * 8);
    }

    @include media-down($size-mobile) {
      padding: 0 calc(var(--scale) * 16);
    }
  }

  &__title {
    font-size: calc(var(--scale) * 120);
    font-weight: 500;
    line-height: 80%;
    letter-spacing: -0.06em;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: $white-color;

    @include media-down($size-tablet) {
      font-size: calc(var(--scale) * 44);
      letter-spacing: -0.07em;
    }
  }

  &__description {
    margin-top: calc(var(--scale) * 32);

    font-size: calc(var(--scale) * 26);
    font-weight: 500;
    line-height: 120%;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: rgba($white-color, .5);

    span {
      color: $white-color;
    }

    @include media-down($size-tablet) {
      width: calc(var(--scale) * 344);
      margin-top: calc(var(--scale) * 12);

      font-size: calc(var(--scale) * 18);
      line-height: 110%;
      letter-spacing: -0.02em;

      br {
        display: none;
      }
    }
  }

  &__cards {
    position: absolute;
    top: calc(var(--scale) * 20);
    right: calc(var(--scale) * 19);

    display: flex;
    flex-direction: column;
    gap: calc(var(--scale) * 4);

    @include media-down($size-tablet) {
      top: calc(var(--scale) * 8);
      right: calc(var(--scale) * 8);
    }

    @include media-down($size-mobile) {
      position: relative;
      top: auto;
      right: auto;
      margin-top: auto;
      padding-left: calc(var(--scale) * 8);

      flex-direction: row;
      overflow: auto;

      -ms-overflow-style: none;
      scrollbar-width: none;
    }
  }

  &__card {
    width: calc(var(--scale) * 320);
    height: calc(var(--scale) * 154.67);
    padding: calc(var(--scale) * 22) calc(var(--scale) * 28);
    box-sizing: border-box;
    position: relative;
    overflow: hidden;

    display: flex;
    flex-direction: column;
    justify-content: space-between;

    border: calc(var(--scale) * 1) solid rgba($white-color, .25);
    border-radius: calc(var(--scale) * 40);
    backdrop-filter: blur(40px);
    box-shadow: 0 5px 20px 0 rgba($black-color, .1) inset;
    background-color: rgba($black-color, .2);

    @include media-down($size-tablet) {
      width: calc(var(--scale) * 200);
      height: calc(var(--scale) * 80);
      padding: calc(var(--scale) * 12) calc(var(--scale) * 16);

      border-radius: calc(var(--scale) * 24);
    }

    @include media-down($size-mobile) {
      min-width: calc(var(--scale) * 200);
    }

    h6 {
      font-size: calc(var(--scale) * 48);
      font-weight: 500;
      line-height: 110%;
      letter-spacing: -0.02em;
      text-align: left;
      text-underline-position: from-font;
      text-decoration-skip-ink: none;
      color: rgba($white-color, .5);

      @include media-down($size-tablet) {
        font-size: calc(var(--scale) * 28);
        line-height: 95%;
      }

      span.white {
        color: $white-color;
      }

      span.green {
        color: #22AE73;
      }
    }

    p {
      font-size: calc(var(--scale) * 20);
      font-weight: 400;
      line-height: 130%;
      text-align: left;
      text-underline-position: from-font;
      text-decoration-skip-ink: none;
      color: rgba($white-color, .5);

      @include media-down($size-tablet) {
        font-size: calc(var(--scale) * 12);
      }
    }

    img {
      position: absolute;
      right: 0;
      top: 0;
      height: 100%;
    }
  }

  &__button {
    margin-top: calc(var(--scale) * 40);

    display: flex;
    align-items: center;
    justify-content: center;
    width: calc(var(--scale) * 358);
    height: calc(var(--scale) * 122);

    border: none;
    border-radius: calc(var(--scale) * 40);
    background-color: #22AE9D;

    font-size: calc(var(--scale) * 32);
    font-weight: 500;
    line-height: 110%;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: $white-color;

    transition: background-color .2s ease-out;
    cursor: pointer;

    &:hover {
      background-color: lighten(#22AE9D, 10%);
    }

    @include media-down($size-tablet) {
      margin-top: auto;

      width: 100%;
      height: calc(var(--scale) * 80);

      border-radius: calc(var(--scale) * 24);

      font-size: calc(var(--scale) * 18);
    }

    @include media-down($size-mobile) {
      width: calc(100% - (var(--scale) * 16));
      margin: calc(var(--scale) * 8) auto 0 auto;
    }
  }

  &__down {
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translateX(-50%) translateY(50%);
    width: calc(var(--scale) * 64);

    cursor: pointer;

    @include media-down($size-tablet) {
      display: none;
    }
  }
}
</style>
